import * as React from "react";

import { cn } from "../../lib/utils";

export function TwScope({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("tw-scope", className)} {...props}>
      {children}
    </div>
  );
}
